import { ApolloProvider } from 'core/net/ApolloProvider';
import { CREATE_CLASSIFICATION } from './graphql/facility.createClassification';
import { CreateClassificationMutation, CreateClassificationMutationVariables } from 'app/__generated__/global';

export const addNoiseEventClassification = async ({
  categoryId,
  classificationName,
  disregardEvents,
}: {
  categoryId: string;
  classificationName: string;
  disregardEvents: boolean;
}) => {
  const { data, error } = await ApolloProvider.global().mutate<
    CreateClassificationMutation,
    CreateClassificationMutationVariables
  >({
    mutation: CREATE_CLASSIFICATION,
    variables: {
      input: {
        categoryId,
        name: classificationName,
        disregardEvents,
      },
    },
  });
  if (!data || error)
    throw new Error(
      `Something went wrong when trying to create classification ${classificationName}: ${error?.message}`
    );
  const { id } = data.facility.classification.createClassification ?? {};
  if (!id) throw new Error(`No ID returned for classification: ${classificationName}`);
  return { classificationId: id };
};
